import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: '9cfa084f-9b73-4c07-8314-1985d4e24329',
    clientToken: 'pub5c04e8984777329f5cdfc803bb1077fa',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'chartflow',
    env: import.meta.env.VITE_STAGE,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: import.meta.env.VITE_VERSION,
    allowedTracingUrls: [/^https:\/\/(?:[a-zA-Z0-9-]+\.)*chartflow\.io\/.*$/],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
});
